// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19bvidpf{padding-left:0}\n._19pk1b66{margin-top:var(--ds-space-050,4px)}\n._2mzuglyw{list-style-type:none}", ""]);
// Exports
module.exports = exports;
